import { Language } from '@getaccept/lib-shared/src/languages/enums/translation';
import { MomentLanguageCode } from '../documents/types/enums/moment-language-code-format';
import { userLanguage } from '../lang';

export class MomentLocaleHelper {
  static getLocale = (): string => {
    let currentLocale = userLanguage();
    if (currentLocale === Language.ZhCn) {
      currentLocale = MomentLanguageCode.ZhCn;
    }
    return currentLocale;
  };
}
